<template>
  <div class="recovery preloader-container">
    <user-name-form
      v-if="!status"
      @formStatus="value => handler(value)"
      @success="msgText => msgHandler(msgText)"
    />
    <h3 v-if="status">{{ successMsg }}</h3>
  </div>
</template>
<script>
import RecoveryByEmailForm from "@/components/auth/RecoveryByEmailForm.vue";
export default {
  name: "RecoveryByEmail",
  data() {
    return {
      status: null,
      successMsg: ""
    };
  },
  components: {
    "user-name-form": RecoveryByEmailForm
  },
  methods: {
    handler(value) {
      this.status = value;
    },
    msgHandler(msgText) {
      this.successMsg = msgText;
    }
  }
};
</script>

<style scoped>
.recovery {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  background-color: #222c44;
}

.recovery__preloader {
  background-color: rgba(47, 58, 87, 0.5);
}
</style>
